import FORMAT_VALIDATIONS from '@/services/formatter_services/enums/FORMAT_VALIDATIONS';

const PERCENTAGE_CONFIG = Object.freeze({
  'de': {
    defaultValue: '0,00 %',
    furtherReplacements: (value) => {
      return value.replace(/\./g, '').replace(/,/g, '.')
    },
    validations: [
      (v) => FORMAT_VALIDATIONS.ONLY_ONE(',', v),
      (v) => FORMAT_VALIDATIONS.MAX_N_AFTER(',', 4, v),
      (v) => FORMAT_VALIDATIONS.MAX_N_BEFORE(',', 4, v),
    ]
  }
});

const MIN_OF_DECIMAL_PLACES = 2;
const MAX_OF_DECIMAL_PLACES = 2;

const getConfigOf = (locale) => {
  return PERCENTAGE_CONFIG[locale];
}

export { PERCENTAGE_CONFIG, MIN_OF_DECIMAL_PLACES, MAX_OF_DECIMAL_PLACES, getConfigOf };
